import { render } from "./AppLayoutAuth.vue?vue&type=template&id=2b28b594"
import script from "./AppLayoutAuth.vue?vue&type=script&lang=js"
export * from "./AppLayoutAuth.vue?vue&type=script&lang=js"

import exportComponent from "/Users/carloslazcanoyoung/PROJECT/MUSS/COMPANY/SOFOFA/IEE/iee-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__